import React from 'react';

/**
 * v2 avatar — initials or image, round radius. Neutral by default; humans are
 * never violet (violet belongs to Robbie's own marks, not user avatars).
 */
export type AvatarSize = 'sm' | 'md' | 'lg';
/** neutral = default humans · action = the signed-in user on navy chrome (mock user card). */
export type AvatarTone = 'neutral' | 'action';

const sizeClasses: Record<AvatarSize, string> = {
  sm: 'h-6 w-6 text-[10px]',
  md: 'h-8 w-8 text-body-sm',
  lg: 'h-10 w-10 text-row-title',
};

const toneClasses: Record<AvatarTone, string> = {
  neutral: 'border border-line bg-neutral-bg text-ink-secondary',
  action: 'border-none bg-action text-white',
};

export interface AvatarProps {
  name: string;
  src?: string;
  size?: AvatarSize;
  tone?: AvatarTone;
  className?: string;
}

const initialsOf = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('');

export const Avatar: React.FC<AvatarProps> = ({ name, src, size = 'md', tone = 'neutral', className = '' }) => (
  <span
    role="img"
    aria-label={name}
    title={name}
    className={`inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-round font-semibold ${toneClasses[tone]} ${sizeClasses[size]} ${className}`}
  >
    {src ? <img src={src} alt={name} className="h-full w-full object-cover" /> : initialsOf(name)}
  </span>
);

export default Avatar;
